import React from "react";
import Cookies from "universal-cookie";
import Button from "./Button";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import ImageSilentInput from "./ImageSilentInput";
import Utils from "../utils/utils";
import loadDocument from "../services/loadDocument";
import LoadingOverlay from "react-loading-overlay";
import { Delete as DeleteIcon } from "@material-ui/icons";
import loadPdfPagamenti from "../services/loadPdfPagamenti";

export default class UploadPdfPagamenti extends React.Component {
  constructor(props) {
    super(props);
    this.count = 0;
    this.state = {
      message: undefined,
      file: undefined,
      alertName: false,
      alertFile: false,
      visible: this.props.show !== false, // Default to visible unless explicitly set to false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({ visible: this.props.show !== false });
    }
  }

  render() {
    console.log("corsoid", this.props.corsoId);

    if (!this.state.visible) {
      return null;
    }

    return (
      <div>
        <div
          style={container}
          onClick={() => {
            this.setState({ visible: false });
            this.props.onClose();
          }}
        >
          <div style={mainClass} onClick={(e) => e.stopPropagation()}>
            {this.state.isLoading ? (
              <LoadingOverlay
                active={this.state.isLoading}
                styles={{
                  content: (base) => ({
                    position: "relative",
                    width: "100%",
                    top: "200px",
                  }),
                }}
                spinner
                text={"Loading your content..."}
              ></LoadingOverlay>
            ) : (
              <div>
                <div
                  style={closeBtn}
                  onClick={() => {
                    this.setState({ visible: false });
                    this.props.onClose();
                  }}
                >
                  ❌
                </div>
                <div style={windowTitle}>Nuovo file</div>
                <br />

                <input
                  style={{ ...input, backgroundColor: "#eeeeee" }}
                  type="text"
                  placeholder="Inserisci nome"
                  value={this.state.message}
                  onChange={(value) => {
                    this.setState({
                      message: value.target.value,
                      alertName: false,
                    });
                  }}
                />
                {this.state.alertName && (
                  <div
                    style={{
                      marginTop: 5,
                      borderRadius: 10,
                      width: 300,
                      height: 32,
                      padding: 5,
                      color: "#c41e3a",
                      fontWeight: "bold",
                    }}
                  >
                    <p>❗ Inserisci nome</p>
                  </div>
                )}
                <br />
                <ImageSilentInput
                  name={""}
                  value={this.state.imageToLoad}
                  onChange={async (base64) => {
                    this.setState({ filecontent: base64, alertFile: false });
                  }}
                />
                {this.state.alertFile && (
                  <div
                    style={{
                      marginTop: 5,
                      borderRadius: 10,
                      width: 300,
                      height: 32,
                      padding: 5,
                      color: "#c41e3a",
                      fontWeight: "bold",
                    }}
                  >
                    <p>❗ Inserisci file</p>
                  </div>
                )}
                {this.state.filecontent && (
                  <div
                    style={{
                      width: "300px",
                      height: 45,
                      boxShadow: "0px 1px 3px lightgrey",
                      backgroundColor: "#F3F3F3",
                      paddingTop: 5,
                      paddingBottom: 5,
                      paddingLeft: 20,
                      paddingRight: 20,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderRadius: 10,
                      cursor: "pointer",
                      marginBottom: 16,
                      marginLeft: 5,
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={require("../images/folder.png")}
                        style={{ height: 30, width: 30, marginTop: 2.5 }}
                        alt="File"
                      />
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "darkgrey",
                          marginLeft: 20,
                          marginTop: 9,
                          textTransform: "none",
                        }}
                      >
                        File
                      </p>
                    </div>
                    <DeleteIcon
                      className="icon"
                      style={{
                        height: "20px",
                        width: "20px",
                        alignSelf: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm("Elimina immagine") == false) return;
                        this.setState({ filecontent: undefined });
                      }}
                    />
                  </div>
                )}

                <br />
                <Button
                  callback={() => {
                    const cookies = new Cookies();
                    const token = cookies.get("token", { path: "/" });
                    const username = cookies.get("username", { path: "/" });
                    let message = this.state.message;
                    let filecontent = this.state.filecontent;

                    if (message == null || message.trim().length === 0) {
                      this.setState({ alertName: true });
                    } else if (!filecontent) {
                      this.setState({ alertFile: true });
                    } else {
                      this.setState({ isLoading: true });
                      loadPdfPagamenti(
                        username,
                        token,
                        this.props.corsoId,
                        message,
                        filecontent
                      )
                        .then((resp) => {
                          this.setState({ isLoading: false });
                          console.log(resp);
                          if (resp.status == "success") {
                            alert("File caricato con successo");
                            this.setState({ visible: false });
                            this.props.onClose();
                          } else {
                            alert("Errore nel caricamento del file");
                          }
                        })
                        .catch((error) => {
                          this.setState({ isLoading: false });
                          console.error(
                            "Errore durante il caricamento:",
                            error
                          );
                          alert("Errore nel caricamento del file");
                        });
                    }
                  }}
                  title={"Carica"}
                ></Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const input = {
  width: "300px",
  padding: "10px",
  borderLeft: 0,
  borderTop: 0,
  borderRight: 0,
  borderBottom: "1px solid darkgrey",
};

const windowTitle = {
  color: "darkgrey",
  fontSize: 30,
  fontWeight: "bold",
  fontFamily: "Teko",
  textAlign: "left",
  marginLeft: 5,
};

const closeBtn = {
  position: "absolute",
  cursor: "pointer",
  right: 10,
  top: 10,
  padding: 10,
  zIndex: 999,
};

const container = {
  position: "fixed",
  display: "block",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  minWidth: "100%",
  minHeight: "100%",
  backgroundColor: "#3C3C3C4D",
  overflowY: "scroll",
  overflowX: "hidden",
  zIndex: 999,
};

const mainClass = {
  paddingBottom: 10,
  position: "absolute",
  left: "calc((100% - 400px)/2",
  top: "100px",
  minWidth: "350px",
  maxHeight: 350,
  minHeight: 350,
  width: "350px",
  background: "white",
  padding: "20px",
  boxShadow: "0px 2px 10px darkgrey",
  borderRadius: "10px",
  bottom: "30px",
};
